import React, { memo } from 'react';
import Box from "@mui/material/Box/Box.js";
import Divider from "@mui/material/Divider/Divider.js";
import Typography from "@mui/material/Typography/Typography.js";
import Logo from "../Logo/Logo.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ProductTitle = function ProductTitle(_ref) {
  var divider = _ref.divider,
    logo = _ref.logo,
    title = _ref.title;
  return /*#__PURE__*/_jsxs(Box, {
    display: "flex",
    alignItems: "center",
    children: [logo || /*#__PURE__*/_jsx(Logo, {
      mark: !!title,
      styles: {
        height: title ? 20 : 30
      }
    }), divider && /*#__PURE__*/_jsx(Divider, {
      orientation: "vertical",
      flexItem: true,
      sx: {
        marginX: 1,
        marginY: 0.25,
        borderColor: 'inherit'
      }
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "overline",
      children: title
    })]
  });
};
ProductTitle.defaultProps = {
  divider: false
};
export default /*#__PURE__*/memo(ProductTitle);